import * as React from 'react';
import {
  Card as MuiCard,
  IconButton,
} from '@material-ui/core';
import {
  MoreVert,
  Room,
} from '@material-ui/icons';

import { categoryIcon } from '../../../utility/categoryIcon';
import { timeAgo } from '../../../utility/timeAgo';

import { ICardFrontProps } from './card-front.interface';

export const CardFront = (props: ICardFrontProps): React.ReactElement => {
  const {
    category,
    categoryColor,
    flipped = false,
    updatedAt,
    pinned = false,
    username,
    color = '#000',
    openContextMenu,
    classes,
  } = props;

  // Blank uses a cream panel, no-category grey, else the category colour. Text/chrome is
  // white on coloured/grey panels, dark on the cream Blank panel (mirrors the content face).
  const panelBg = category === 'Blank'
    ? '#f5efd2'
    : (!category ? '#c4c4c4' : categoryColor ?? '#c4c4c4');
  const isBlank = category === 'Blank';
  const onColor = isBlank ? color : '#fff';

  return (
    <MuiCard className={flipped ? classes.cardCoverFlip : classes.cardCover}>
      <div className={classes.cardInnerPanel} style={{ background: panelBg }}>
        {/* HEADER matches the content face: icon (left) + centered title + ellipsis (right) */}
        <div className={classes.cardHeaderRow}>
          {categoryIcon(category, categoryColor, { size: 22 })}
          <span className={classes.cardTitle} style={{ color: onColor }}>
            {category ? category : 'No category'}
            {pinned && <Room className={classes.pin} style={{ color: onColor }} />}
          </span>
          <IconButton className={classes.cardHeaderMenuBtn} onClick={openContextMenu}>
            <MoreVert style={{ color: isBlank ? '#c4c4c4' : '#fff' }} />
          </IconButton>
        </div>

        {/* Hero icon */}
        <div className={classes.cardCoverHero}>
          {categoryIcon(category, categoryColor, { size: 115 })}
        </div>

        {/* FOOTER matches the content face: "Name · N min" */}
        <div className={classes.cardFooter} style={{ color: onColor }}>
          {username} · {timeAgo(updatedAt)}
        </div>
      </div>
    </MuiCard>
  );
};
